import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/all';
gsap.registerPlugin([ScrollToPlugin]);

const DEFAULTS = {
  sectionSelector: '[data-title]',
  navSelector: '.l-header__nav',
  anchorSelector: 'a',
  activeClass: 'is-active',
  rootMargin: '-50% 0%',
}

export class Navigation {
  constructor(options = {}) {
    this.opts = { ...DEFAULTS, ...options }

    const isSP = window.matchMedia('(max-width: 743px)').matches

    // SP/PCで対象のnavを切り替え
    const navs = [...document.querySelectorAll(this.opts.navSelector)]
    this.headerNav = isSP
      ? navs.find((n) => n.classList.contains('u-hidden-sp'))
      : navs.find((n) => n.classList.contains('u-visible-sp'))

    if (!this.headerNav) return

    this.els = [...document.querySelectorAll(this.opts.sectionSelector)]
    if (!this.els.length) return

    this.headerAnchors = [...this.headerNav.querySelectorAll(this.opts.anchorSelector)]

    // 下線要素を生成
    this.underline = document.createElement('span')
    this.underline.className = 'l-header__nav__underline'
    this.headerNav.appendChild(this.underline)
    gsap.set(this.underline, { opacity: 0 })

    this.setIntersectionObserver()
    this.setResizeObserver()
  }

  calcUnderline() {
    const active = this.headerAnchors.find((a) => a.classList.contains(this.opts.activeClass))
    if (!active) return
    const item = active.closest('.l-header__nav__item')

    // position:fixedでもずれないようにnavからの相対位置で計算
    const navRect = this.headerNav.getBoundingClientRect()
    const itemRect = item.getBoundingClientRect()
    const relativeLeft = itemRect.left - navRect.left + this.headerNav.scrollLeft

    gsap.to(this.underline, {
      x: relativeLeft,
      width: item.offsetWidth,
      opacity: 1,
      duration: 0.4,
      ease: 'power2.out',
    })

    // スマホのみ横スクロール
    if (window.matchMedia('(max-width: 743px)').matches) {
      gsap.to(this.headerNav, {
        scrollTo: {
          x: relativeLeft - (this.headerNav.offsetWidth / 2) + (item.offsetWidth / 2),
        },
        duration: 0.4,
        ease: 'power2.out',
      })
    }
  }

  setActive(idx) {
    const sectionId = this.els[idx].id
    this.headerAnchors.forEach((a) => a.classList.remove(this.opts.activeClass))
    const matched = this.headerAnchors.find((a) => a.getAttribute('href') === `#${sectionId}`)
    if (matched) {
      matched.classList.add(this.opts.activeClass)
      this.calcUnderline()
    }
  }

  setIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return
          const idx = this.els.indexOf(target)
          if (idx === -1) return
          this.setActive(idx)
        })
      },
      { rootMargin: this.opts.rootMargin, threshold: 0 }
    )
    this.els.forEach((s) => observer.observe(s))
  }

  setResizeObserver() {
    const observer = new ResizeObserver(() => this.calcUnderline())
    observer.observe(this.headerNav)
  }

  destroy() {
    if (this.underline) this.underline.remove()
  }
}